import React, { useEffect, useState } from "react";
import LandingPage from "./homeLanding";
import Teams from "./team";
import Services from "./ourServices";
import HomeContact from "./homeContact";
import AwesomeFeatures from "./awesomeFeatures";
import HomeCarousel from "./homeCarousel";
import HomeAbout from "./homeAbout";
import SideScroll from "../../common/sideScroll";

const Home = () => {
  return (
    <div className="home">
      <LandingPage></LandingPage>
      <HomeCarousel></HomeCarousel>
      <div className="container-fluid">
        <div className="row mx-0 justify-content-around">
          <div className="col">
            <div>
              <HomeAbout></HomeAbout>
              <AwesomeFeatures></AwesomeFeatures>
              <Teams></Teams>
              <Services></Services>
              <HomeContact></HomeContact>
            </div>
          </div>
          <SideScroll></SideScroll>
        </div>
      </div>
    </div>
  );
};

export default Home;
